import React from "react";

import "../minhas-chaves/Style.css"
import { Link } from "react-router-dom";

import { useEffect } from "react";
import { getAll } from "../../../../services/pix.service";
import PixRow from "../pix-row/pixRow";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';

export default function () {
    const [rows, setRows] = useState([])
    useEffect( ()=>{
        const getKeys = async () => {
            try {
              const response = await getAll();
              setRows(response); // Armazena os dados no estado para renderização
            } catch (error) {
              console.error('Erro ao fazer a requisição:', error);
            }
          };
        getKeys()
    },[])
    return (
        <div className="minhas-chaves-pix">
            <div className="container">
                <div className='titulo row'>
                    <div className='col-xl-8'>
                        <p>Minhas Chaves Pix</p>
                    </div>

                    <div className="col-xl-2">
                        <Link to={"/pagina-pix"}>
                            <button style={{ backgroundColor: "var(--secondary-color)" }}>Nova transferencia</button>
                        </Link>
                    </div>

                    <div className="col-xl-2">
                        <Link to={"/nova-chave-pix"}>
                            <button style={{ backgroundColor: "var(--secondary-color)" }}>Cadastrar Chave</button>
                        </Link>
                    </div>
                </div>

                <div className="chaves-pix">
                    <div>
                        <h1>Suas Chaves Pix</h1>
                    </div>

                    <div className="registra-chave">
                        <div className="row">

                            <div className="col-xl-6">
                                <h2>Gerencie suas chaves</h2>
                            </div>
                        </div>
                    </div>

                    <div className="chave-cadastrada">
                        <p>Chaves já Cadastradas</p>
                    </div>
                    { rows.length > 0 ?
                        rows.map((data)=> {
                            return <PixRow data={data} key={data.id}></PixRow>} )
                        :
                        <div>
                            <p>Nenhuma Chave Pix Cadastrada</p>
                        </div>
                    }
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}